export const BEEWO_REDIRECT_URL = process.env.REACT_APP_BEEWO_REDIRECT_URL
export const connectSocialProviderURL = () =>
  `${process.env.REACT_APP_API_HOSTNAME}/open-api/social/login`
